import { actionTypes } from './action';

var initialState = {
    name: 'vivek',
    number: '123',
    address: '122233'
}

// // REDUCERS
export const contact = (state = initialState, action) => {
    // console.log(state);
    switch (action.type) {
        case actionTypes.NAME:
        return { ...state, name: action.name };
        case actionTypes.NUMBER:
            return { ...state, number: action.number };
        case actionTypes.ADDRESS:
        return { ...state, address: action.address };

        default: return state
    }
}



// WEBPACK FOOTER //
// store/contact/reducer.ts